import React, { useRef } from 'react';
import { Paperclip, FileText, X } from 'lucide-react';
export interface Attachment {
  id: string;
  name: string;
  size: number;
}
interface AttachmentsFieldProps {
  label?: string;
  value: Attachment[];
  onChange: (files: Attachment[]) => void;
}

// File upload from the computer; keeps name and size of each attached file
export function AttachmentsField({
  label = 'Allegati',
  value,
  onChange
}: AttachmentsFieldProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const addFiles = (files: FileList | null) => {
    if (!files || files.length === 0) return;
    const stamp = Date.now();
    onChange([...value, ...Array.from(files).map((f, i) => ({
      id: `${stamp}-${i}`,
      name: f.name,
      size: f.size
    }))]);
    if (inputRef.current) inputRef.current.value = '';
  };
  return <div className="flex flex-col gap-1.5" data-id="element-1666" data-mp="25qggwoj6cezz">
      <span className="block text-sm font-medium text-slate-700" data-id="element-1667" data-mp="25tui3tg3qi5u">{label}</span>
      <label className="flex items-center justify-center gap-2 rounded-xl border-2 border-dashed border-slate-200 px-4 py-5 text-sm text-slate-500 cursor-pointer hover:border-seform-orange/60 transition-colors" onDragOver={e => e.preventDefault()} onDrop={e => {
      e.preventDefault();
      addFiles(e.dataTransfer.files);
    }} data-id="element-1668" data-mp="2aorp6uttmhg3">
        <Paperclip className="h-4 w-4 text-seform-orange" data-id="element-1669" data-mp="3ao067xc35isg" />
        <span data-id="element-1670" data-mp="35pf7k2chf764">
          Trascina i file qui o <span className="font-medium text-seform-orange" data-id="element-1671" data-mp="35qgvh7eljo59">sfoglia dal computer</span>
        </span>
        <input ref={inputRef} type="file" multiple className="sr-only" onChange={e => addFiles(e.target.files)} data-id="element-1672" data-mp="30y6xr578pjsf" />
      </label>
      {value.length > 0 && <ul className="mt-1 divide-y divide-slate-100 rounded-xl border border-slate-100" data-id="element-1673" data-mp="2s05111ujhday">
          {value.map(file => <li key={file.id} className="flex items-center gap-3 px-3 py-2" data-id="element-1674" data-mp="2i04dt4tjud1h">
              <FileText className="h-4 w-4 shrink-0 text-slate-400" data-id="element-1675" data-mp="2i27dkgki7kje" />
              <span className="flex-1 min-w-0 truncate text-sm text-slate-800" data-id="element-1676" data-mp="28bpbfj4l1ajc">{file.name}</span>
              <span className="text-xs text-slate-400 whitespace-nowrap" data-id="element-1677" data-mp="2dcmv6058qcmy">{formatSize(file.size)}</span>
              <button type="button" onClick={() => onChange(value.filter(f => f.id !== file.id))} className="rounded-md p-1 text-slate-400 hover:bg-red-50 hover:text-red-600 transition-colors" aria-label={`Rimuovi ${file.name}`} data-id="element-1678" data-mp="1yfma2fhk1fxg">
                <X className="h-3.5 w-3.5" data-id="element-1679" data-mp="2w1jpu54jv75p" />
              </button>
            </li>)}
        </ul>}
    </div>;
}
export function AttachmentsList({
  files
}: {
  files: Attachment[];
}) {
  if (files.length === 0) return <p className="text-sm text-slate-500" data-id="element-1680" data-mp="2m9x4hfyhzrp8">Nessun allegato</p>;
  return <ul className="space-y-1.5" data-id="element-1681" data-mp="3a0avr499dmir">
      {files.map(f => <li key={f.id} className="flex items-center gap-2 text-sm text-slate-800" data-id="element-1682" data-mp="3esuaw5nlgppo">
          <FileText className="h-4 w-4 text-slate-400" data-id="element-1683" data-mp="13dbzfz4dygp3" />
          <span className="truncate" data-id="element-1684" data-mp="13br5aalzgzrr">{f.name}</span>
          <span className="text-xs text-slate-400" data-id="element-1685" data-mp="yf0lbc725k12">{formatSize(f.size)}</span>
        </li>)}
    </ul>;
}
function formatSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}